const deleteMethod = async (endpoint, authToken) => {

    try {

        let response = await fetch(endpoint, {
            method: 'DELETE',
            headers: {
                'x-api-key': authToken
            }
        });

        if (response.status !== 200) throw response;
        return response;
    } catch (e) {
        console.log(`error from delete method - ${endpoint}`, e);
        throw e;
    }
};

export default deleteMethod;
